import React from "react";

const SortIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="sort_icon"
      data-name="sort"
      {...props}
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83301 16.6667H7.49967V6.66671H9.99967L6.66634 3.33337L3.33301 6.66671H5.83301V16.6667ZM16.6663 13.3334H14.1663V3.33337H12.4997V13.3334H9.99967L13.333 16.6667L16.6663 13.3334Z"
        fill={props.fill || "#6B7A94"}
      />
    </svg>
  );
};

export default SortIcon;
